
/**
 *
 * @param {Array} arr
 * @param {Function} _filter (el,i) =>  {}
 */
export function allAre(arr, _filter) {

    var count = arr.filter(_filter).length;
    return arr.length === count;
}
export function allAreSame(arr) {
    var first = arr[0];
    var count = arr.filter(el=>el === first).length;
    return arr.length === count;
}
export function someAre(arr, _filter) {

    var count = arr.filter(_filter).length;
    return count > 0;
}

export function  unique(arr){
  function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
  }

  var u = arr.filter( onlyUnique );
  return u;
}

export function uniqueBy(arrArg, propertyName) {
  var foundList = [];

  return arrArg.filter(function(elem, index, arr) {
    foundList.push(elem[propertyName]);
    return foundList.filter( a => a === elem[propertyName] ).length < 2 ;
  });
};

export function groupBy(arr, key){
    const initialValue = {};
    return arr.reduce((acc, cval) => {
        const myAttribute = cval[key];
        acc[myAttribute] = [...(acc[myAttribute] || []), cval]
        return acc;
    }, initialValue);
};

export function nextOrFirst(list:Array, current) {
  var index = current !== undefined && list.indexOf( current ) || 0;
  var length = list.length;
  if(  length > index + 1 ){
    return list[ index + 1 ]
  }
  return list[0];
};

export function prevOrLast(list:Array, current) {
  var index = current !== undefined && list.indexOf( current ) || 0;
  var length = list.length;
  if( index - 1 < 0 ){
    return list[length - 1];
  }
  return list[index - 1];
};

// null
export function nextOrNull(list:Array, current, {by=null}={}) {
    if(by){
        var index = current !== undefined && list.findIndex( el=>el[by] === current[by] ) || 0;
    }else{

        var index = current !== undefined && list.indexOf( current ) || 0;
    }
  var length = list.length;
  if(  length > index + 1 ){
    return list[ index + 1 ]
  }
  return null;
};

export function prevOrNull(list:Array, current, {by=null}={}) {
    if(by){
        var index = current !== undefined && list.findIndex( el=>el[by] === current[by] ) || 0;
    }else{

        var index = current !== undefined && list.indexOf( current ) || 0;
    }
  var length = list.length;
  if( index - 1 < 0 ){
    return null;
  }
  return list[index - 1];
};

/**
 * If arr[] contains neddle
 * @param {String} neddle
 * @param {Array} arr
 */
export function oneOf(neddle, arr = []){
    return arr.includes(neddle);
}
export function isNotOneOf(neddle, arr = []){
    return !arr.includes(neddle);
}


export function objToArray(obj){
    return Object.keys(obj).map(k=> obj[k]);
}


export function arrayMove(array, fromIndex, toIndex) {
	const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

	if (startIndex >= 0 && startIndex < array.length) {
		const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

		const [item] = array.splice(fromIndex, 1);
		array.splice(endIndex, 0, item);
	}
    return array;
}
